(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["btl-product-story"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('btl-design-story')) {
  customElements.define('btl-design-story', class extends HTMLElement {
    connectedCallback() {
      this.stopMotion();
      this.stopBorder();
      const surface = this.querySelector('.btl-product-story');
      this.startBorder(surface);
      const preference = window.matchMedia('(prefers-reduced-motion: reduce)');
      if (this.dataset.motion !== 'true' || this.seen || preference.matches || !surface ||
          typeof surface.animate !== 'function' || typeof IntersectionObserver === 'undefined') return;
      this.preference = preference;
      this.onPreferenceChange = event => { if (event.matches) { this.seen = true; this.stopMotion(); } };
      preference.addEventListener('change', this.onPreferenceChange);
      const observer = new IntersectionObserver(entries => {
        if (this.observer !== observer || this.seen || !this.isConnected || !entries.some(entry => entry.isIntersecting)) return;
        this.seen = true;
        this.observer.disconnect();
        const timing = { duration: 420, easing: 'cubic-bezier(.22,.61,.36,1)' };
        this.animations = [surface.animate([
          { opacity: .72, transform: 'translateY(6px)' },
          { opacity: 1, transform: 'translateY(0)' }
        ], timing)];
        const mark = surface.querySelector('.btl-product-story__mark');
        if (mark) this.animations.push(mark.animate([
          { transform: 'scale(1)' }, { transform: 'scale(1.06)' }, { transform: 'scale(1)' }
        ], { duration: 1000, delay: 180, easing: 'ease-in-out', iterations: 1 }));
      }, { threshold: .15 });
      this.observer = observer;
      observer.observe(surface);
    }
    stopMotion() {
      this.observer?.disconnect();
      this.observer = null;
      this.animations?.forEach(animation => animation.cancel());
      this.animations = null;
      if (this.preference && this.onPreferenceChange) this.preference.removeEventListener('change', this.onPreferenceChange);
      this.preference = null;
      this.onPreferenceChange = null;
    }
    startBorder(surface) {
      if (this.dataset.borderMotion !== 'true' || !surface || typeof ResizeObserver === 'undefined' ||
          typeof IntersectionObserver === 'undefined' || typeof CSS === 'undefined' ||
          !CSS.supports('offset-path', 'path("M0 0 L1 1")') ||
          !(CSS.supports('mask-composite', 'exclude') || CSS.supports('-webkit-mask-composite', 'xor'))) return;
      const shell = surface.querySelector('.btl-product-story__orbit');
      const trail = surface.querySelector('.btl-product-story__orbit-trail');
      if (!shell || !trail || typeof trail.animate !== 'function') return;
      const owner = { shell, trail, visible: false, animation: null, duration: 0,
        reduced: window.matchMedia('(prefers-reduced-motion: reduce)'),
        forced: window.matchMedia('(forced-colors: active)') };
      this.border = owner;
      const current = () => this.border === owner && this.isConnected;
      owner.sync = () => {
        if (!current()) return;
        const allowed = !owner.reduced.matches && !owner.forced.matches;
        shell.style.opacity = allowed && owner.animation ? '1' : '0';
        if (!owner.animation) return;
        if (allowed && owner.visible && !document.hidden) owner.animation.play();
        else owner.animation.pause();
      };
      owner.measure = () => {
        if (!current()) return;
        const w = shell.offsetWidth, h = shell.offsetHeight;
        const stroke = Math.min(5, Math.max(1, parseFloat(getComputedStyle(shell).paddingLeft) || 1.5));
        if (!(w > stroke && h > stroke)) {
          owner.animation?.cancel(); owner.animation = null; owner.geometry = null; owner.sync(); return;
        }
        const radius = Math.max(0, Math.min(parseFloat(getComputedStyle(surface).borderTopLeftRadius) || 18, w / 2, h / 2) - stroke / 2);
        const key = [w, h, radius, stroke].join(':');
        if (owner.geometry === key) return;
        const progress = owner.animation && owner.duration ? ((Number(owner.animation.currentTime) || 0) % owner.duration) / owner.duration : 0;
        owner.animation?.cancel();
        const x = stroke / 2, y = x, width = w - stroke, height = h - stroke, r = radius;
        const path = `M${x+r} ${y} H${x+width-r} A${r} ${r} 0 0 1 ${x+width} ${y+r} V${y+height-r} A${r} ${r} 0 0 1 ${x+width-r} ${y+height} H${x+r} A${r} ${r} 0 0 1 ${x} ${y+height-r} V${y+r} A${r} ${r} 0 0 1 ${x+r} ${y} Z`;
        trail.style.offsetPath = `path("${path}")`;
        const perimeter = 2 * (width + height - 4 * r) + 2 * Math.PI * r;
        const rate = Math.min(150, Math.max(30, Number(this.dataset.orbitRate) || 110));
        owner.duration = perimeter / rate * 1000;
        owner.animation = trail.animate([{ offsetDistance: '0%' }, { offsetDistance: '100%' }], {
          duration: owner.duration, iterations: Infinity, easing: 'linear'
        });
        owner.animation.pause();
        owner.animation.currentTime = progress * owner.duration;
        owner.geometry = key;
        owner.sync();
      };
      document.addEventListener('visibilitychange', owner.sync);
      owner.reduced.addEventListener('change', owner.sync);
      owner.forced.addEventListener('change', owner.sync);
      owner.resize = new ResizeObserver(owner.measure);
      owner.resize.observe(surface);
      owner.observer = new IntersectionObserver(entries => {
        if (!current()) return;
        owner.visible = entries.some(entry => entry.isIntersecting);
        owner.sync();
      }, { threshold: 0 });
      owner.observer.observe(surface);
      owner.measure();
    }
    stopBorder() {
      const owner = this.border;
      this.border = null;
      if (!owner) return;
      owner.resize.disconnect();
      owner.observer.disconnect();
      owner.animation?.cancel();
      document.removeEventListener('visibilitychange', owner.sync);
      owner.reduced.removeEventListener('change', owner.sync);
      owner.forced.removeEventListener('change', owner.sync);
      owner.shell.style.opacity = '0';
    }
    disconnectedCallback() { this.stopMotion(); this.stopBorder(); }
  });
}
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["btl_size_chart"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('btl-nested-size-guide'))customElements.define('btl-nested-size-guide',class extends HTMLElement{
 connectedCallback(){this.root=this.closest('product-info');this.trigger=this.querySelector('[data-btl-chart-open]');if(!this.root||!this.trigger)return;this.place();this.observer=new MutationObserver(()=>this.place());this.observer.observe(this.root,{childList:true,subtree:true});}
 place(){if(!this.isConnected)return;let label;for(const input of this.root.querySelectorAll('.product-form__input')){const candidate=input.querySelector('legend,label');if(candidate&&/^sizes?\s*[:：]?/i.test(candidate.textContent.trim())){label=candidate;break;}}if(label){label.classList.add('btl-size-label-row');this.trigger.classList.add('btl-size-chart-link--inline');if(this.trigger.parentElement!==label)label.append(this.trigger);}else{this.trigger.classList.remove('btl-size-chart-link--inline');const chart=this.querySelector('.btl-size-chart');if(chart&&this.trigger.parentElement!==chart)chart.prepend(this.trigger);}}
 disconnectedCallback(){this.observer?.disconnect();}
});
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["share"] && !Shopify.designMode) return;
  try {
    if(!customElements.get('btl-nested-share'))customElements.define('btl-nested-share',class extends HTMLElement{connectedCallback(){const target=this.closest('product-info')?.querySelector('.btl-product-gallery-actions');if(target&&this.parentElement!==target)target.append(this);}});
  } catch(e) { console.error(e); }
})();

})();
